import { api } from '@src/api/api'
import { MessagesType } from '@src/store/ducks/app/types'

export const contactApi = {
  callBack(name: string, phone: string, account?: string) {
    return api.post('/v1/call-back', { name, phone, account })
  },
  tariffRequest(name: string, phone: string, address: string, tariff: string) {
    return api.post('/v1/tariff-request', {
      name, phone, address, tariff,
    })
  },
  getMessages() {
    return api.get<MessagesType>('/v1/messages')
  },
}
